// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__syV0E","text":"LimitedAccessBanner_text__1tB8Q","button":"LimitedAccessBanner_button__1RPxC"};